import Blue from '~/core';

new Blue({
  name: 'Profile',
  selector: '.profile',
  setup(profile) {
    const items = [...profile.querySelectorAll('.profile__item')];
    const inputEvents =
      'click.stop.prevent enter.stop.prevent space.stop.prevent';

    const toggle = (item, siblings) => {
      let delay = siblings.filter(s => s.classList.contains('is-active')).length
        ? 200
        : 0;
      siblings.forEach(s => s.classList.remove('is-active'));
      setTimeout(() => item.classList.toggle('is-active'), delay);
    };

    const close = item => {
      if (!document.body.classList.contains('using-mouse')) {
        setTimeout(() => {
          if (document.activeElement.closest('.profile__item') !== item) {
            item.classList.remove('is-active');
          }
        }, 10);
      }
    };

    const closeAll = e => {
      if (e.target.closest('.profile') !== profile) {
        items.forEach(i => i.classList.remove('is-active'));
      }
    };

    items.forEach(item => {
      const card = item.querySelector('.profile__card');
      const siblings = items.filter(i => i !== item);

      this.$addEvents(item, 'focusout', () => close(item));
      this.$addEvents(card, inputEvents, () => toggle(item, siblings));
    });

    this.$addEvents(document, 'click', closeAll);
  },
});
